<template>
    <div class="left_panel">

        <!-- 검색 영역 -->
        <HServiceSearch/>

        <!-- 달력 영역 -->
        <DatePicker/>

        <!-- 예약현황 -->
        <ReservationMonitor/>
        
        <!-- 공지사항 -->
        <ReservationDateNote/>
        
        <!-- 근무현황 -->
        <WorkState/>
    </div>
</template>


<script>
const moment = require('@/util/MPMoment')

import HServiceSearch from '../Common/HServiceSearch/HServiceSearch.vue'
import DatePicker from './DatePicker/DatePicker.vue'
import ReservationMonitor from './Monitor/ReservationMonitor.vue'
import ReservationDateNote from './DateNote/ReservationDateNote.vue'
import WorkState from './WorkState/WorkState.vue'

import { setSelectedDate, sheetAxis } from '../../sheet-axis'

export default {
    components: { HServiceSearch, DatePicker, ReservationMonitor, ReservationDateNote, WorkState },

    mounted() {
        if (sheetAxis.selectedDate == undefined) {
            setSelectedDate(moment().startOf('days'))
        }
    }
}
</script>